import '../3rd-party/prefix-bootstrap-theme-1.css'
// import './scss/style.scss'
// import './js/start-meeting'
// import './js/join-meeting'



jQuery('document').ready(function($){
  
  $( "#inception_date" ).datepicker({
    dateFormat: "dd/mm/yy",
    onSelect:function(val,salkd){
      let dateVal=val;
      let dateArr=dateVal.split("/");
      dateVal=parseInt(dateArr[2])+1;
      // let newDate=new Date(dateArr[0]+"/"+dateArr[1]+"/"+dateVal);
      var renewalDate = dateArr[0]+"/"+dateArr[1]+"/"+dateVal
      
      // console.log('picked:' + val)
      // console.log(renewalDate)
      $("#renewal_date").val(renewalDate);
    }
  });
  
  
})


